import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-image-with-text',
  templateUrl: './image-with-text.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./image-with-text.component.scss']
})
export class ImageWithTextComponent implements OnInit {
  @Input() imageText: string;
  @Input() routerLink:string;
  @Input() imageTextPath:string;
  @Input() buttonText:string;
  @Input() routerButton:string;
  @Input()imageUrl: string;
  @Input() isProductsPage: boolean;
  @Input() subTitle: string
  @Input() subImgUrl: string
  @Input() type: string
  @Input() isHomePage: boolean;
  constructor() { }

  ngOnInit(): void {
  }

}
